<template lang="pug">
#bloco-cultura-monitoramento-agricola(
    v-loading='!culturas.length',
    element-loading-background='rgb(255 255 255 / 0%)'
)
    .bloco-cultura-monitoramento-agricola-container--loading
        transition(name='el-fade-in-linear', v-if='culturas.length')
            .bloco-cultura-monitoramento-agricola-container
                h3 {{ $t('mensagens.monitoramentoAgricola.selecioneUmaCultura') }}
                .bloco-cultura-monitoramento-agricola__button
                    button(
                        v-for='(cultura, index) in culturas',
                        @click='selecionarCultura(cultura, index)',
                        :class='"el-button el-button--default is-round " + cultura.classe'
                    )
                        | {{ $t(`mensagens.cultura.${cultura.codigo}`) }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'BlocoCulturaMonitoramentoAgricola',

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idCulturasSelecionados: [],
     * }
     *
     */
    emits: ['atualizar-filtro-avancado'],
    props: {
        removerCultura: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            culturas: [],
            idCulturasSelecionados: []
        };
    },
    watch: {
        removerCultura: function () {
            if (this.removerCultura.remover) {
                this.removerCulturaSelecionada(this.removerCultura.id);
            }
        }
    },
    created() {
        this.buscarCulturas();
    },

    computed: {
        ...mapGetters(['culturaFiltrada'])
    },

    methods: {
        ...mapActions(['setCulturaFiltrada', 'limparCulturaFiltrada']),

        removerCulturaSelecionada(culturaId) {
            for (let culturaIndex in this.culturas) {
                if (this.culturas[culturaIndex].nome === culturaId) {
                    this.culturas[culturaIndex].classe = '';
                    this.idCulturasSelecionados = [];
                    this.$emit('atualizar-filtro-avancado', {
                        idCulturas: [...this.idCulturasSelecionados]
                    });
                    this.$set(
                        this.culturas,
                        culturaIndex,
                        this.culturas[culturaIndex]
                    );
                    this.limparCulturaFiltrada();
                    break;
                }
            }
        },
        selecionarCultura(cultura, index) {
            if (!cultura.classe) {
                this.alterarClasseBtnCultura(cultura);
            } else {
                cultura.classe = '';
                this.idCulturasSelecionados = [];
            }
            this.$set(this.culturas, index, cultura);

            if (cultura.classe === '') {
                this.$emit('atualizar-filtro-avancado', {
                    idCulturas: [...this.idCulturasSelecionados]
                });
            } else {
                this.setCulturaFiltrada(cultura.nome);
                this.$emit(
                    'atualizar-filtro-avancado',
                    { idCulturas: [...this.idCulturasSelecionados] },
                    cultura.nome
                );
            }
        },
        alterarClasseBtnCultura(cultura) {
            cultura.classe =
                'bloco-cultura-monitoramento-agricola__button--active';
            this.idCulturasSelecionados = [cultura.id];
            for (let culturaIndex in this.culturas) {
                if (
                    this.culturas[culturaIndex].classe !== '' &&
                    this.culturas[culturaIndex].id !== cultura.id
                ) {
                    this.culturas[culturaIndex].classe = '';
                }
            }
        },
        buscarCulturas() {
            UtilsService.getCulturasMonitoramento()
                .then(({ data }) => {
                    setTimeout(() => {
                        Object.keys(data).forEach(item => {
                            if (data[item].codigo !== 'OUTROS') {
                                if (data[item].nome === this.culturaFiltrada) {
                                    data[item].classe =
                                        'bloco-cultura-monitoramento-agricola__button--active';
                                    this.idCulturasSelecionados = [
                                        data[item].id
                                    ];
                                }
                                this.culturas.push(data[item]);
                            }
                        });
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de culturas.'
                    });
                    throw error;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-cultura-monitoramento-agricola {
    .bloco-cultura-monitoramento-agricola__button--active {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .bloco-cultura-monitoramento-agricola-container {
        h3 {
            margin-bottom: 10px;
            margin-top: 15px;
            color: var(--var(--black));
            font-weight: 500;
        }
        .el-button.is-round {
            margin: 2px 3px 0px 2px;
        }
        .el-button.is-round:not(:first-child) {
            margin: 2px 3px 2px 2px;
        }
        .el-button.is-round {
            box-shadow: 0px 0px 2px 0px var(--block-shadow);
            border-radius: 20px;
            padding: 9px 20px;
            min-width: 149px;
            color: var(--primary);
        }
    }

    .bloco-cultura-monitoramento-agricola-container--loading {
        min-height: 70px;
    }
}
</style>
